import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';

export type NotesType = 'FAILURE' | 'RESCHEDULE';

export type AddNotesPayload =
  | {
      taskAssignmentId: string;
      notes: string;
      type: 'FAILURE';
    }
  | {
      taskAssignmentId: string;
      notes: string;
      type: 'RESCHEDULE';
      plannedDate: string;
    };

const useAddNotesMutation = (
  options?: UseMutationOptions<AxiosResponse, Error, AddNotesPayload>,
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = { ...options };

  const mutation = useMutation<AxiosResponse, Error, AddNotesPayload>({
    mutationFn: ({ taskAssignmentId, ...rest }: AddNotesPayload) =>
      API.post(`/taskassignment/event/${taskAssignmentId}`, rest),
    onSuccess: (data, variables, context) => {
      // Invalidate relevant queries to reflect the updated task data
      queryClient.invalidateQueries({
        queryKey: ['tasks'],
      });
      queryClient.invalidateQueries({
        queryKey: ['ag-task'],
      });
      queryClient.invalidateQueries({
        queryKey: ['taskDetail'],
      });
      queryClient.invalidateQueries({
        queryKey: ['task-history'],
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });

  return mutation;
};

export default useAddNotesMutation;
